module.exports = __webpack_public_path__ + "img/illu1.01da360d.png";